// Helper for updating ATC buttons + price-by-weight for a section
window.updateAddToCartButtons = function ({
  sectionId,
  disable = true,
  text = false,
  modifyClass = true,
  variant = null,
}) {
  if (!sectionId) return;

  const productForm = document.getElementById(`product-form-${sectionId}`);
  if (!productForm) return;

  const productTemplate = productForm
    .closest(".product-form")
    ?.getAttribute("template");

  const submitButtons = document.querySelectorAll(".single-add-to-cart-button");
  if (!submitButtons.length) return;

  submitButtons.forEach((submitButton) => {
    const submitButtonText = submitButton.querySelector(
      ".single-add-to-cart-button--text"
    );
    if (!submitButtonText) return;

    const submitButtonLabel = submitButtonText.querySelector(".atc-label");
    const submitButtonPrice = submitButtonText.querySelector(".atc-price");
    if (!submitButtonLabel) return;

    if (disable) {
      submitButton.setAttribute("disabled", "disabled");
      if (text) {
        submitButtonLabel.textContent = text;
      }
    } else {
      submitButton.removeAttribute("disabled");
      submitButton.classList.remove("loading");

      if (productTemplate && productTemplate.includes("pre-order")) {
        submitButtonLabel.textContent =
          window.theme?.variantStrings?.preOrder || "Pre-order";
      } else if (variant && variant.available === false) {
        submitButtonLabel.textContent =
          window.theme?.variantStrings?.soldOut ||
          window.theme?.variantStrings?.unavailable ||
          "Sold out";
      } else {
        submitButtonLabel.textContent =
          window.theme?.variantStrings?.addToCart || "Add to cart";
      }

      // Update price when we have a variant (existing logic)
      if (submitButtonPrice && variant) {
        const format =
          window.theme?.settings?.money_with_currency_format || "${{amount}}";

        /* Middle dot, matching the design's "Lägg i korg · 1 040 kr" and the
           same separator snippets/custom-add-to-cart-button.liquid renders on
           first paint. Both have to agree: this line rewrites the label on
           every variant change, so a pipe here silently undid the Liquid one
           the moment a size was picked. */
        submitButtonPrice.textContent = ` · ${formatMoney(
          variant.price,
          format
        ).replace(",", " ")}`;
      }

      // Update price-by-weight for this section, if helper is present
      if (variant && window.updatePriceByWeightForSection) {
        window.updatePriceByWeightForSection(variant, sectionId);
      }
    }
  });

  if (!modifyClass) return;
};
